import { Grid, TextField, Typography, MenuItem, Box } from '@mui/material';
import { useTheme } from '@mui/material';
import { Field } from 'formik';
import { PET_TYPE_OPTIONS } from '../../constants/petConstants';
import { ImageInput } from '../../../../shared/components/ui/ImageInput';

interface FormContentProps {
  values: any;
  errors: any;
  touched: any;
  isSubmitting: boolean;
  mode: 'create' | 'edit';
  isAdmin: boolean;
  authUser: any;
  setFieldValue: (field: string, value: any) => void;
}

export function FormContent({ 
  values, 
  errors, 
  touched, 
  isSubmitting, 
  mode,
  setFieldValue,
}: FormContentProps) {
  const theme = useTheme();
  
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Typography fontWeight={600} fontSize={16} color={theme.palette.text.primary} mb={2}>
          Dados Básicos
        </Typography>
      </Grid>

      <Grid item xs={12} sm={6}>
        <Field
          as={TextField}
          fullWidth
          label="Nome"
          name="nome"
          required
          disabled={isSubmitting}
          error={!!(touched.nome && errors.nome)}
          helperText={touched.nome && errors.nome}
          placeholder="Ex: Rex"
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <Field
          as={TextField}
          select
          fullWidth
          label="Tipo"
          name="tipo"
          required
          disabled={isSubmitting}
          error={!!(touched.tipo && errors.tipo)}
          helperText={touched.tipo && errors.tipo}
        >
          {PET_TYPE_OPTIONS.map(option => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Field>
      </Grid>

      <Grid item xs={12} sm={6}>
        <Field
          as={TextField}
          fullWidth
          label="Raça"
          name="raca"
          required
          disabled={isSubmitting}
          error={!!(touched.raca && errors.raca)}
          helperText={touched.raca && errors.raca}
          placeholder="Ex: Labrador"
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <Field
          as={TextField}
          fullWidth
          label="Idade (anos)"
          name="idade"
          type="number"
          required
          disabled={isSubmitting}
          error={!!(touched.idade && errors.idade)}
          helperText={touched.idade && errors.idade}
          inputProps={{ min: 0, max: 50 }}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <Field
          as={TextField}
          fullWidth
          label="Peso (kg)"
          name="peso"
          type="number"
          required
          disabled={isSubmitting}
          error={!!(touched.peso && errors.peso)}
          helperText={touched.peso && errors.peso}
          inputProps={{ min: 0, max: 200, step: 0.1 }}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <Field
          as={TextField}
          fullWidth
          label="Cor"
          name="cor"
          required
          disabled={isSubmitting}
          error={!!(touched.cor && errors.cor)}
          helperText={touched.cor && errors.cor}
          placeholder="Ex: Preto"
        />
      </Grid>

      <Grid item xs={12}>
        <Field
          as={TextField}
          fullWidth
          label="Observações"
          name="observacoes"
          multiline
          rows={3}
          disabled={isSubmitting}
          error={!!(touched.observacoes && errors.observacoes)}
          helperText={touched.observacoes && errors.observacoes}
          placeholder="Observações adicionais sobre o pet..."
        />
      </Grid>

      <Grid item xs={12}>
        <Box>
          <Typography fontWeight={600} fontSize={16} color={theme.palette.text.primary} mb={2}>
            Foto do Pet
          </Typography>
          <ImageInput
            onChange={(files) => setFieldValue('foto', files)}
            label="Selecionar foto do pet"
            maxFiles={1}
          />
          {touched.foto && errors.foto && (
            <Typography color="error" variant="caption" sx={{ mt: 1, display: 'block' }}>
              {errors.foto}
            </Typography>
          )}
        </Box>
      </Grid>
    </Grid>
  );
} 